<div class="row discover-view discover-page-updates">
  <mode-discover-main-content [username]="owner.username"></mode-discover-main-content>
  <mode-discover-sidebar *ngIf="!thoughtspotIntegrated"></mode-discover-sidebar>
</div>
